import Markdown from '@/components/Markdown'
import SecondaryPageLayout from '@/layouts/SecondaryPageLayout'
import { forwardRef, useEffect } from 'react'

const HomePage = forwardRef(({ index }: { index?: number }, ref) => {
  useEffect(() => {
    document.title = window.hallway.universe.appName
    history.replaceState(null, '')
  }, [])

  return (
    <SecondaryPageLayout ref={ref} index={index} hideBackButton hideTitlebarBottomBorder title="">
      <div className="px-6 pt-6 pb-8 max-w-3xl mx-auto prose prose-neutral dark:prose-invert">
        <Markdown content={window.hallway.universe.homeMarkdown || ''} />
      </div>
    </SecondaryPageLayout>
  )
})

HomePage.displayName = 'HomePage'
export default HomePage
